import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios.js';
import './Register.css';

const Password = () => {
    const navigate = useNavigate();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword !== confirmPassword) {
            setError('รหัสผ่านใหม่ไม่ตรงกัน');
            return;
        }

        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const response = await api.put(
                `/users/${user.id}/change-password`,
                {
                    currentPassword,
                    newPassword
                }
            );

            if (response.status === 200) {
                setShowSuccessModal(true);
            }
        } catch (err) {
            if (err.response?.status === 401) {
                setError('รหัสผ่านปัจจุบันไม่ถูกต้อง');
            } else {
                setError(err.response?.data?.message || 'เปลี่ยนรหัสผ่านไม่สำเร็จ');
            }
        }
    };

    const handleConfirmSuccess = () => {
        setShowSuccessModal(false);
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user.isAdmin) {
            navigate('/');
        } else {
            navigate('/lessons');
        }
    };

    return (
        <div className="register-container">
            <h2>เปลี่ยนรหัสผ่าน</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>รหัสผ่านปัจจุบัน:</label>
                    <input
                        type="password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label>รหัสผ่านใหม่:</label>
                    <input
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label>ยืนยันรหัสผ่านใหม่:</label>
                    <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                </div>
                {error && <div className="error-message">{error}</div>}
                <button type="submit">เปลี่ยนรหัสผ่าน</button>
            </form>

            {showSuccessModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>เปลี่ยนรหัสผ่านสำเร็จ!</h3>
                        <p>รหัสผ่านของคุณได้ถูกเปลี่ยนเรียบร้อยแล้ว</p>
                        <button className="to-login-button" onClick={handleConfirmSuccess}>
                            กลับไปหน้าแรก
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Password;